// lib files
import { ShowRowContent, ShowDetails } from '@/lib/types/api/show-data';

// types
import type { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

// components
import MyListShowPoster from '@/components/MyList/MyListShows/MyListShowPoster';

// styles
import styles from './MyListShowPosterGrid.module.scss';

interface MyListShowPosterGridProps {
  shows: (ShowRowContent | ShowDetails)[];
  showBadgeFlags?: ShowBadgeFlags;
}

const MyListShowPosterGrid = (props: MyListShowPosterGridProps) => {
  const { shows, showBadgeFlags } = props;
  return (
    <div className={styles.my_list_show_poster_grid}>
      {shows.map((show, i: number) => {
        return (
          <MyListShowPoster show={show as ShowRowContent} key={i} showBadgeFlags={showBadgeFlags} />
        )
      })}
    </div>
  );
};

export default MyListShowPosterGrid;
